import * as React from 'react';
import { FC, useState } from 'react';

import { useIntl } from 'react-intl';

import Toggle from 'components/toggle';
import { useSetLoyaltyDonationUpchargeMutation } from 'generated/rbi-graphql';

import { Container, Description, Text, Title, ToggleContainer } from './round-up-toggle.styled';
import { IRoundUpToggleProps } from './types';

/**
 *
 * Round Up Toggle Component
 *
 */

const RoundUpToggle: FC<IRoundUpToggleProps> = ({ cardId, donationStatus }) => {
  const { formatMessage } = useIntl();
  const [toggle, setToggle] = useState<boolean>(donationStatus);
  const [setLoyaltyDonationUpchargeMutation, { loading }] = useSetLoyaltyDonationUpchargeMutation({
    onCompleted: result => setToggle(result.setLoyaltyDonationUpcharge?.donationUpcharge ?? false),
  });

  const roundUpUpdate = async () => {
    return await setLoyaltyDonationUpchargeMutation({
      variables: {
        cardId,
        donationUpcharge: !toggle,
      },
    });
  };

  return (
    <Container data-testid="round-up-toggle-container">
      <Title>
        <Text>{formatMessage({ id: 'roundUpTitle' })}</Text>
        <ToggleContainer>
          <Toggle
            disabled={loading}
            checked={toggle}
            data-testid="round-up-toggle"
            onChange={roundUpUpdate}
          />
        </ToggleContainer>
      </Title>
      <Description>{formatMessage({ id: 'roundUpDescription' })}</Description>
    </Container>
  );
};

export default RoundUpToggle;
